export default "__VITE_ASSET__0zzVKzjJ__"